module.exports = __webpack_public_path__ + "static/media/27-3.d6fe2887.mp3";